// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zoom-move{transition:transform .3s ease-out}@keyframes zoomInY{0%{opacity:0;transform:scaleY(0)}50%{opacity:1;transform:scaleY(1)}}.zoomInY{animation-name:zoomInY}@keyframes zoomOutY{0%{opacity:1}50%{opacity:0;transform:scaleY(0)}to{opacity:0}}.zoomOutY{animation-name:zoomOutY}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
